<script>
  //End
  let buysell;
  let selected;
  let selected2;
  let scrip;
  let b;
  let s;
  let contractTypes = ["Future", "Options"];
  let optionTypes = ["Call", "Put"];
  $: if (buysell == "Buy") {
    b = "bg-green-lt";
    s = "";
  } else if (buysell == "Sell") {
    s = "bg-red-lt";
    b = "";
  }
</script>

<div
  class="modal modal-blur fade"
  id="modal-add"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Add Position</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        />
      </div>
      <div class="modal-body">
        <div class="mb-3">
          <div class="form-selectgroup">
            <label class="form-selectgroup-item">
              <input
                type="radio"
                bind:group={buysell}
                class="form-selectgroup-input"
                value="Buy"
              />
              <span class="form-selectgroup-label {b}">Buy</span>
            </label>
            <label class="form-selectgroup-item">
              <input
                type="radio"
                bind:group={buysell}
                class="form-selectgroup-input"
                value="Sell"
              />
              <span class="form-selectgroup-label {s}">Sell</span>
            </label>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-5">
            <div class="mb-3">
              <div class="input-group input-group-flat">
                <input
                  type="text"
                  bind:value={scrip}
                  class="form-control"
                  placeholder="SYMBOL"
                  list="wizards-list"
                />
              </div>
            </div>
          </div>
          <datalist id="wizards-list" style="height:3em;overflow:hidden">
            <option>NIFTY</option>
            <option>NIFTYBANK</option>
            <option>SBIN</option>
            <option>HDFC</option>
            <option>ICICI</option>
            <option>NIFTY</option>
            <option>NIFTYBANK</option>
            <option>SBIN</option>
            <option>HDFC</option>
            <option>ICICI</option>
            <option>NIFTY</option>
            <option>NIFTYBANK</option>
            <option>SBIN</option>
            <option>HDFC</option>
            <option>ICICI</option>
          </datalist>
          <div class="col-lg-3">
            <div class="mb-3">
              <select class="form-select" bind:value={selected}>
                {#each contractTypes as item}
                  <option value={item}>{item}</option>
                {/each}
              </select>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="mb-3">
              <select class="form-select" bind:value={selected2}>
                {#each optionTypes as item}
                  <option value={item}>{item}</option>
                {/each}
              </select>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="mb-3">
              <span class="form-label">Entry By</span>
              <div class="form-selectgroup">
                <label class="form-selectgroup-item">
                  <input
                    type="radio"
                    bind:group={buysell}
                    class="form-selectgroup-input"
                    value="Buy"
                  />
                  <span class="form-selectgroup-label">Strike</span>
                </label>
                <label class="form-selectgroup-item">
                  <input
                    type="radio"
                    bind:group={buysell}
                    class="form-selectgroup-input"
                    value="Sell"
                  />
                  <span class="form-selectgroup-label">Value</span>
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="mb-3">
              <span class="form-label">Strike Price(ATM)</span>
              <select class="form-select" bind:value={selected}>
                {#each contractTypes as item}
                  <option value={item}>{item}</option>
                {/each}
              </select>
            </div>
          </div>
          <div class="mb-3">
            <div>
              <label class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" />
                <span class="form-check-label">Set Profit Target</span>
              </label>
              <label class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" checked />
                <span class="form-check-label">Set Stop Loss</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <!--Second Part-->

      <div class="modal-footer">
        <a href="/" class="btn btn-link link-secondary" data-bs-dismiss="modal">
          Cancel
        </a>
        <a href="/" class="btn btn-primary ms-auto" data-bs-dismiss="modal">
          <!-- Download SVG icon from http://tabler-icons.io/i/plus -->
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="icon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
            ><path stroke="none" d="M0 0h24v24H0z" fill="none" /><line
              x1="12"
              y1="5"
              x2="12"
              y2="19"
            /><line x1="5" y1="12" x2="19" y2="12" /></svg
          >
          Add
        </a>
      </div>
    </div>
  </div>
</div>
